import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table, TableBody, TableCell, TableHead, TableRow, TextField,
} from '@material-ui/core';
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { fetchMasterCondition } from '../../actions';
import {
  CircularProgressLoader,
  Modal,
  MasterConditionManagementEdit,
  ValidationError,
  MasterConditionManagementBlock,
} from '../../components';

import './mastercondition.global.scss';
import saveIcon from '../../assets/svg/save.svg';
import editIcon from '../../assets/svg/edit.svg';
import blockIcon from '../../assets/svg/block.svg';
import unblockIcon from '../../assets/svg/unblock.svg';
import '../LayoutWrapperMain/LayoutWrapperMain.global.scss';

interface ConditionRow {
  rowId: number;
  label: string;
  field: string;
  dataKey: string;
  enableKey: string;
  toggleId: string;
  type: 'number' | 'boolean';
}

const CONDITION_ROWS: ConditionRow[] = [
  {
    rowId: 1, label: 'Minimum Age', field: 'age', dataKey: 'minimumAge', enableKey: 'isMinimumAgeEnable', toggleId: 'age', type: 'number',
  },
  {
    rowId: 2, label: 'User’s existence in the platform', field: 'existance', dataKey: 'minimumAccountAge', enableKey: 'isMinimumAccountAgeEnable', toggleId: 'existance', type: 'number',
  },
  {
    rowId: 3, label: 'Having a premium subscription', field: 'condition', dataKey: 'havingPremiumSubscription', enableKey: 'isHavingPremiumSubscriptionEnable', toggleId: 'havingPremiumSubscription', type: 'boolean',
  },
  {
    rowId: 4, label: 'Minimum number of followers', field: 'followers', dataKey: 'noOfFollowers', enableKey: 'isNoOfFollowersEnable', toggleId: 'noOfFollowers', type: 'number',
  },
  {
    rowId: 5, label: 'Session duration', field: 'sessionDur', dataKey: 'sessionDuration', enableKey: 'isSessionDurationEnable', toggleId: 'sessionDuration', type: 'number',
  },
];

interface Props {
  masterconditionmanagement: any;
  fetchMasterConditionList: any;
}

const MasterConditionManagementComponent: React.FC<Props> = (props: Props) => {
  const { masterconditionmanagement, fetchMasterConditionList } = props;
  const [editableRow, setEditableRow] = React.useState<any>({ id: null });
  const [showModal, setShowModal] = React.useState(false);
  const [idx, setIdx] = React.useState<any>();
  const [validationexiting, setValidationExisting] = React.useState<any>({});
  const [edit, setEdit] = React.useState<any>({
    show: false,
    id: null,
  });
  const [block, setBlock] = React.useState<any>({
    show: false,
    id: null,
  });
  const [unblock, setUnBlock] = React.useState<any>({
    show: false,
    id: null,
  });

  const handleModalClose = () => {
    setShowModal(false);
    setEdit({ ...edit, show: false, id: null });
    setBlock({ ...block, show: false, id: null });
    setUnBlock({ ...unblock, show: false, id: null });
    setIdx(0);
  };
  React.useEffect(() => {
    fetchMasterConditionList();
  }, [fetchMasterConditionList]);

  const rawData = masterconditionmanagement.data;
  const conditionData = rawData && !Array.isArray(rawData) ? rawData : null;

  const startEdit = (row: ConditionRow) => {
    setEdit({ show: true, id: row.rowId });
    setIdx(row.rowId);
    setValidationExisting({});
    const value = row.type === 'boolean'
      ? (conditionData[row.dataKey] ? 'true' : 'false')
      : conditionData[row.dataKey];
    setEditableRow({ id: conditionData._id, [row.field]: value });
  };

  const confirmEdit = (row: ConditionRow) => {
    const value = editableRow[row.field];
    if (value === '' || value === undefined || value === null) {
      setValidationExisting({ [row.field]: 'Please enter the required field' });
      return;
    }
    setValidationExisting({});
    setShowModal(true);
    setEdit({ show: true, id: row.rowId });
  };

  const openToggle = (row: ConditionRow) => {
    setShowModal(true);
    setEdit({ show: false, id: null });
    setIdx(0);
    if (conditionData[row.enableKey]) {
      setBlock({ show: true, id: row.toggleId });
    } else {
      setUnBlock({ show: true, id: row.toggleId });
    }
  };

  const renderCondition = (row: ConditionRow) => {
    if (idx !== row.rowId) {
      return (
        <div className="imagewrapper">
          <p>
            {row.type === 'boolean'
              ? (conditionData[row.dataKey] ? 'Yes' : 'No')
              : (conditionData[row.dataKey] ?? '-')}
          </p>
        </div>
      );
    }
    if (row.type === 'boolean') {
      return (
        <FormControl fullWidth>
          <InputLabel id={`${row.field}-select-label`}>Condition</InputLabel>
          <Select
            labelId={`${row.field}-select-label`}
            id={`${row.field}-select`}
            value={editableRow[row.field]}
            label="Condition"
            onChange={(e: any) => setEditableRow({ ...editableRow, [row.field]: e.target.value })}
          >
            <MenuItem value="true">Yes</MenuItem>
            <MenuItem value="false">No</MenuItem>
          </Select>
        </FormControl>
      );
    }
    return (
      <>
        <TextField
          name={row.field}
          type="number"
          value={editableRow[row.field]}
          onChange={(e: any) => {
            setEditableRow({ ...editableRow, [row.field]: e.target.value });
          }}
        />
        {validationexiting[row.field] !== undefined
          && <ValidationError error={validationexiting[row.field]} />}
      </>
    );
  };

  const renderActions = (row: ConditionRow) => (
    <div className="actionBtnsWrapper">
      {edit.show && edit.id === row.rowId && !showModal ? (
        <div>
          <img
            src={saveIcon}
            role="presentation"
            alt="save"
            width="35"
            title="Save"
            height="35"
            onClick={() => confirmEdit(row)}
          />
        </div>
      ) : (
        <div>
          <img
            src={editIcon}
            role="presentation"
            alt="edit"
            width="35"
            title="Edit"
            height="35"
            onClick={() => startEdit(row)}
          />
        </div>
      )}
      <div>
        <img
          src={conditionData[row.enableKey] ? blockIcon : unblockIcon}
          role="presentation"
          alt={conditionData[row.enableKey] ? 'block' : 'unblock'}
          width="35"
          title={conditionData[row.enableKey] ? 'Block' : 'Unblock'}
          height="35"
          onClick={() => openToggle(row)}
        />
      </div>
    </div>
  );

  const editingRow = CONDITION_ROWS.find((r) => r.rowId === edit.id);

  return (
    <>
      <Modal
        id="mastercondition"
        isOpen={showModal}
        onClose={handleModalClose}
        onManageDisableScrolling={() => null}
        lightCloseButton={false}
      >
        {
          edit.show && editingRow && (
            <MasterConditionManagementEdit
              handleModalClose={handleModalClose}
              fetchPriceList={() => {
                fetchMasterConditionList();
                setEdit({
                  show: false,
                  id: null,
                });
                setIdx(0);
              }}
              editableRow={{ [editingRow.field]: editableRow[editingRow.field] }}
            />
          )
        }
        {
          block.show && (
            <MasterConditionManagementBlock
              handleModalClose={handleModalClose}
              id={block.id}
              fetchPriceList={() => {
                fetchMasterConditionList();
              }}
              status="blocked"
            />
          )
        }
        {
          unblock.show && (
            <MasterConditionManagementBlock
              handleModalClose={handleModalClose}
              id={unblock.id}
              fetchPriceList={() => {
                fetchMasterConditionList();
              }}
              status="unblocked"
            />
          )
        }
      </Modal>
      <div className="page_header">
        <div className="buttonWrapper buttonWrapper_s">
          <h2>Master Condition Management</h2>
        </div>
      </div>
      <hr />
      <div>
        <p>Rules for Campaigns/Events/Channels</p>
      </div>
      <div className="dataTableCover">
        <Table
          size="medium"
          aria-label="enhanced table"
        >
          <TableHead>
            <TableRow>
              <TableCell>
                S.No
              </TableCell>
              <TableCell>
                Description
              </TableCell>
              <TableCell>
                Conditions
              </TableCell>
              <TableCell>
                Status
              </TableCell>
              <TableCell>
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {masterconditionmanagement.loadingInProgress
              ? (
                <TableRow>
                  <TableCell>
                    <CircularProgressLoader />
                  </TableCell>
                </TableRow>
              )
              : conditionData === null
                ? (
                  <TableRow>
                    <TableCell colSpan={5}>
                      {masterconditionmanagement.loadingError
                        ? 'You do not have permission to view master conditions.'
                        : 'No data found'}
                    </TableCell>
                  </TableRow>
                )
                : CONDITION_ROWS.map((row) => (
                  <TableRow key={row.rowId}>
                    <TableCell>
                      {row.rowId}
                    </TableCell>
                    <TableCell>
                      {row.label}
                    </TableCell>
                    <TableCell>
                      {renderCondition(row)}
                    </TableCell>
                    <TableCell>
                      {conditionData[row.enableKey] ? 'Active' : 'Inactive'}
                    </TableCell>
                    <TableCell>
                      {renderActions(row)}
                    </TableCell>
                  </TableRow>
                ))}
          </TableBody>
        </Table>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  masterconditionmanagement: state.masterconditionmanagement,
});

const mapDispatchToProps = (dispatch: any) => ({
  fetchMasterConditionList: () => dispatch(fetchMasterCondition()),
});

const MasterConditionManagement = compose<React.ElementType>(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(MasterConditionManagementComponent);

export default MasterConditionManagement;
